import React from 'react';

/**
 * NoopBlockView — renderiza nada.
 * Usado como View+Edit pra @types legados do Plone AgSUS (eyebrow,
 * featured-image, newsitem-meta) que existem nos items migrados mas
 * cuja renderização visual nosso NewsItemView já cobre. Registrar
 * esses tipos no blocksConfig (mesmo como no-op) evita que o Volto
 * Form quebre no submit ao iterar blocks_layout.
 */
const NoopBlockView = () => null;

export default NoopBlockView;
